import React, { FC, useMemo } from 'react';
import ChipWithTooltip from '@components/ChipWithTooltip';
import useFunctionControls from '@components/EntityDrawers/drawers/Relationship/components/RelationshipContext/hooks/useFunctionControls';
import { RelationOption } from '@components/EntityDrawers/drawers/Relationship/constants/types';
import { Autocomplete } from '@components/Inputs/Autocomplete';
import ListItemWithInfo from '@components/Inputs/Autocomplete/items/ListItemWithInfo';
import { MAX_VISIBLE_CHIP_SYMBOLS } from '@constants/entities/ui';
import { useProject } from '@context/Project/ProjectProvider';

import { formatOptions, formatValues } from '../helpers';

type Props = {
  prentOptions: RelationOption[];
};

const FunctionDropdown: FC<Props> = ({ prentOptions }) => {
  const { viewOnly } = useProject();

  const { values, handleChangeValues } = useFunctionControls();

  const options = useMemo(() => formatOptions(prentOptions), [prentOptions]);
  const formattedValues = useMemo(
    () => formatValues(values, options),
    [values, options],
  );

  return (
    <Autocomplete
      label="Function control requirements"
      placeholder="Control requirement"
      options={options}
      value={formattedValues}
      readOnly={viewOnly}
      onChange={(_, newValue) =>
        handleChangeValues(newValue.map((v) => v.value))
      }
      multiple
      itemComponent={ListItemWithInfo}
      renderTags={(value, getTagProps) =>
        value.map(({ label }, index) => {
          const { key, ...chipProps } = getTagProps({ index });
          return (
            <ChipWithTooltip
              key={key}
              label={label}
              tooltip={{
                disableHoverListener: label.length < MAX_VISIBLE_CHIP_SYMBOLS,
              }}
              chip={chipProps}
            />
          );
        })
      }
    />
  );
};

export default FunctionDropdown;
